import styled from 'styled-components';
import { useTranslate } from 'react-t7e';
import { FC } from 'react';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import Image from 'next/image';
import { AboutUsSection } from 'src/modules/about-us/components/shared/AboutUsSection';
import { media } from 'src/styles/designs';
import { AboutUsHeading } from 'src/modules/about-us/components/shared/AboutUsHeading';
import { AboutUsContactButton } from 'src/modules/about-us/components/shared/AboutUsContactButton';
import neauviaMapImage from 'src/modules/about-us/assets/neauvia-map.png';

const Container = styled(AboutUsSection)`
  display: grid;
  grid-template-areas:
    'heading'
    'map'
    'description';
  margin-bottom: 32px;

  ${media.w.greaterThanOrEqual.desktop} {
    grid-template-areas:
      'heading map'
      'description map';
    grid-template-columns: 'auto auto';

    margin-bottom: 107px;
  }
`;

const StyledHeading = styled(AboutUsHeading)`
  grid-area: heading;
  margin-bottom: 41px;

  ${media.w.greaterThanOrEqual.desktop} {
    margin-bottom: 0;
    width: 302px;
  }
`;

const Description = styled.div`
  margin: 16px 0;

  ${media.w.greaterThanOrEqual.desktop} {
    max-width: 302px;
    margin: 32px 0;
  }
`;

const DescriptionWrapper = styled.div`
  width: 100%;
  display: flex;

  ${media.w.greaterThanOrEqual.desktop} {
    justify-content: flex-end;
    align-items: flex-start;
  }
`;

const HeaderWrapper = styled.div`
  width: 100%;
  display: flex;

  ${media.w.greaterThanOrEqual.desktop} {
    justify-content: flex-end;
    align-items: flex-end;
  }
`;

const ImageContainer = styled.div`
  grid-area: map;
  position: relative;
  height: 200px;
  width: 100%;

  ${media.w.greaterThanOrEqual.desktop} {
    width: 713px;
    height: 395px;
  }
`;

const DescriptionArea = styled.div`
  grid-area: description;
  display: flex;
  flex-direction: column;
`;

export const AboutUsMap: FC = () => {
  const { _ } = useTranslate();

  return (
    <Container>
      <HeaderWrapper>
        <StyledHeading>
          <Markdown>{_('Neauvia in the world')}</Markdown>
        </StyledHeading>
      </HeaderWrapper>
      <DescriptionWrapper>
        <DescriptionArea>
          <Description>
            <Markdown>
              {_(
                'Established in 2012 as a scientifically-based medical aesthetics company, NEAUVIA has evolved into a vibrant, high-growth multinational corporation with production sites and subsidiaries in Italy, Switzerland, France, Spain, Germany, United-Kingdom, Poland and U.S.',
              )}
            </Markdown>
          </Description>
          <AboutUsContactButton />
        </DescriptionArea>
      </DescriptionWrapper>
      <ImageContainer>
        <Image
          src={neauviaMapImage}
          quality={90}
          objectFit="contain"
          layout="fill"
        />
      </ImageContainer>
    </Container>
  );
};
